export class CommonHelper {
    public static isNullOrEmpty(str: any): boolean {
        if (str === undefined || str === null || (str + "").trim().length == 0) {
            return true;
        } else {
            return false;
        }
    }

    public static formatDate(date: Date, fmt: string) {
        let ret;
        const opt = {
            "Y+": date.getFullYear().toString(),
            "m+": (date.getMonth() + 1).toString(),
            "d+": date.getDate().toString(),
            "H+": date.getHours().toString(),
            "M+": date.getMinutes().toString(),
            "S+": date.getSeconds().toString(),
        };
        for (const k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
            }
        }
        return fmt;
    }

    public static downFixed(num, fix) {
        let result = "0";
        if (Number(num) && fix > 0) {
            fix = +fix || 2;
            num = num + "";
            if (/e/.test(num)) {
                result = num;
            } else if (!/\./.test(num)) {
                result = num + `.${Array(fix + 1).join("0")}`;
            } else {
                num = num + `${Array(fix + 1).join("0")}`;
                const reg = new RegExp(`-?\\d*.\\d{0,${fix}}`);
                result = reg.exec(num)[0];
            }
        }
        if (fix == 0) {
            const dotIndex = num.toString().indexOf(".");
            result = dotIndex > -1 ? num.toString().substr(0, dotIndex) : num;
        }
        return result;
    }

    /***Replace Special Symbols in html eg:change "&amp;" to "&" */
    public static ReplaceSpecialSymbols(s: string) {
        s = s.replace(/&amp;/g, "&");
        s = s.replace(/&quot;/g, "“");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&laquo;/g, "«");
        s = s.replace(/&raquo;/g, "»");
        s = s.replace(/&lsquo;/g, "‘");
        s = s.replace(/&rsquo;/g, "’");
        s = s.replace(/&ldquo;/g, "“");
        s = s.replace(/&rdquo;/g, "�?");
        s = s.replace(/&sect;/g, "§");
        s = s.replace(/&copy;/g, "©");
        s = s.replace(/&hellip;/g, "…");
        s = s.replace(/&oplus;/g, "⊕");
        s = s.replace(/&nabla;/g, "∇");
        s = s.replace(/&times;/g, "×");
        s = s.replace(/&divide;/g, "÷");
        s = s.replace(/&plusmn;/g, "±");
        s = s.replace(/&radic;/g, "√");
        s = s.replace(/&infin;/g, "∞");
        s = s.replace(/&ang;/g, "∠");
        s = s.replace(/&int;/g, "∫");
        s = s.replace(/&deg;/g, "°");
        s = s.replace(/&ne;/g, "≠");
        s = s.replace(/&equiv;/g, "≡");
        s = s.replace(/&le;/g, "≤");
        s = s.replace(/&ge;/g, "≥");
        s = s.replace(/&perp;/g, "⊥");
        s = s.replace(/&there4;/g, "∴");
        s = s.replace(/&pi;/g, "π");
        s = s.replace(/&sup1;/g, "¹");
        s = s.replace(/&sup2;/g, "²");
        s = s.replace(/&sup3;/g, "³");
        s = s.replace(/&crarr;/g, "↵");
        s = s.replace(/&larr;/g, "�?");
        s = s.replace(/&uarr;/g, "↑");
        s = s.replace(/&rarr;/g, "→");
        s = s.replace(/&darr;/g, "↓");
        s = s.replace(/&lArr;/g, "�?");
        s = s.replace(/&uArr;/g, "⇑");
        s = s.replace(/&rArr;/g, "⇒");
        s = s.replace(/&dArr;/g, "⇓");
        s = s.replace(/&alpha;/g, "α");
        s = s.replace(/&beta;/g, "β");
        s = s.replace(/&gamma;/g, "γ");
        s = s.replace(/&Delta;/g, "Δ");
        s = s.replace(/&theta;/g, "θ");
        s = s.replace(/&lambda;/g, "λ");
        s = s.replace(/&Sigma;/g, "Σ");
        s = s.replace(/&tau;/g, "τ");
        s = s.replace(/&omega;/g, "ω");
        s = s.replace(/&Omega;/g, "Ω");
        s = s.replace(/&bull;/g, "•");
        s = s.replace(/&ndash;/g, "-");
        return s;
    }

    public static RemoveHtmlTag(s: string) {
        const RemoveHTMLTag = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/;
        const reg = new RegExp(RemoveHTMLTag, "g");
        s = s.replace(reg, "");
        return s;
    }

    public static IsDateType(date) {
        return Object.prototype.toString.call(date) === "[object Date]";
    }

    public static isJSON(str) {
        if (typeof str == "string" && str) {
            try {
                const obj = JSON.parse(str);
                if (typeof obj == "object" && obj) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    }

    public static getOptionsTxt(key, Options: Dictionary[]) {
        let str = "";
        for (let i = 0; i < Options.length; i++) {
            if ((Options[i].key + "").toLowerCase() === (key + "").toLowerCase()) {
                str = Options[i].value + "";
                return str;
            }
        }
        return str;
    }

    public static IsIOS(): boolean {
        return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    }
    public static IsAndroid(): boolean {
        return /(Android)/i.test(navigator.userAgent);
    }
    public static IsPC(): boolean {
        return !this.IsIOS() && !this.IsAndroid();
    }

    public static IsSafari(): boolean {
        //https://www.cnblogs.com/both-eyes/p/10078432.html now we use method 2 to solve
        return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    }
}

export interface Dictionary {
    key: any;
    value: any;
}
